import clsx from 'clsx';
import React from 'react';

interface SubtitleProps {
    as?: 'h2' | 'h3' | 'h4' | 'h5' | 'p';
    className?: string;
    children: React.ReactNode;
}

const Subtitle: React.FC<SubtitleProps> = ({ as: Tag = 'h3', className, children }) => {
    return (
        <Tag className={clsx('font-heading text-lg font-semibold', className)}>
            {children}
        </Tag>
    );
};

export default Subtitle;
